<template>
  <div class="login">
  	<div class="loginBox">
  		<div class="loginHeader">
  			<div class="fl">
  				<img src="../assets/image/logo3.png"/>
  			</div>
  			<div class="fr">
  			</div>
  		</div>
  		<div class="loginContent">
  			<div class="fl">
  				<el-carousel>
			      <el-carousel-item v-for="(item,index) in imgList" :key="index">
			       	<img :src="item.url" alt="" />
			      </el-carousel-item>
			    </el-carousel>
  			</div>
  			<div class="fl" >
  				<div v-show="dengluFn" class="dengluBox">
	  				<div class="fromHeader" style="overflow: hidden;">
	  					<span>BATS登录</span>
	  					<span v-if="false" @click="dengluFn=false" title="点击去注册账户">注册···<i class="el-icon-arrow-right"></i></span>
	  				</div>
	  				<div class="btnDx">
	  					<div  @click="yzmFn()" :class="{'active':mmshowBool}">
	  						密码登录
	  					</div>
	  					<!--<button @click="mmFn()" v-if="mmshowBool">使用短信验证码登录</button>
	  					<button @click="yzmFn()" v-if="yzmshowBool"> 使用密码登录</button>-->
	  				</div>
	  				<div class="fromIpt">
	  					<!--密码-->
	  					<div v-if="mmshowBool">
	  						<input type="text" name="" id="" v-model="ruleForm2.userName" class="psd" placeholder="用户名称"/>
	  					</div>
	  					<div v-if="mmshowBool" style="position: relative;" v-show="pwdBool" class="div-bordershadow">
			  				<!--<el-input type="password" v-model="ruleForm2.userpwd" autocomplete="off" size="medium" show-password placeholder="用户密码"></el-input>-->
			  				
			  				<input class="psd" :type="pwdType" placeholder="登陆密码"  maxlength="18"
		                 v-model="ruleForm2.userPwd">
		        	  <img src="./../assets/image/showpwd.png" class="eye" v-show="eye" alt="" @click="changeType()" title="隐藏密码">
		        	  <img src="./../assets/image/hidepwd.png" class="eye" alt="" v-show="!eye" @click="changeType()" title="查看密码">
			  			</div>
			  			<div>
								<el-checkbox v-model="checked">记住密码</el-checkbox>
							</div>
							<div class="dlBtn">
								<button @click="login1" v-if="mmshowBool">登录</button>
							</div>
	  				</div>
  				</div>
  			</div>
  		</div>
  		<div class="loginFooter">
  			<div>
  				<p>Store, sync, and share files online</p>
  				<span>
  					All your photos, videos, and documents available anywhere, anytime.
  				</span>
  			</div>
  		</div>
  	</div>
  </div>
</template>


<script>
	import {login,users_reg,company_reg,send_msg_reg,users_tel_chk,login_by_tel,send_msg_login} from './http/api.js'
	import { mapMutations } from 'vuex'
export default {
  data () {
    return {
    	imgList:[
        {url:require('./../assets/image/timg.png')},
        {url:require('./../assets/image/timg.png')},
        {url:require('./../assets/image/timg.png')},
        {url:require('./../assets/image/timg.png')},
        {url:require('./../assets/image/timg.png')},
        {url:require('./../assets/image/timg.png')},
      ],
      pwdType: 'password', // 密码类型
      openeye: require('./../assets/image/showpwd.png'), //图片地址
      ruleForm2:{
      	userName:'',
      	userPwd:'',
      },
      yzmshow:true,
      qyyzmshow:true,
      dlyzmshow:true,
      checked:false,
      codeBool:false,
      pwdBool:true,
      isloading:false,
      eye:false,
      yzmshowBool:false,
      mmshowBool:true,
      checkLogin:2,
      dengluFn:true,
      zhuceFn:false,
      zsmcval:'',
      xxdzval:'',
      lxdhval:'',
      glzNameval:'',
      glzlxPhoneval:'',
      yzmval:'',
      yhsjnum:'',
      yhmmval:'',
      count:'',
      timer:null, 
      dlcount:'',
      dltimer:null, 
      qycount:'',
      qytimer:null,
      zczysjnum:'',
      zczysjyzm:'',
      grzcsn:"",
      qyzcsn:"",
      dlzcsn:"",
      gryzmval:'',
      qyyzmval:'',
      dlphoneval:'',
      dlyzmval:''
    }
  },
  mounted(){
  	this.getCookie();
  	this.getCookietoken();
  },
  methods:{
  	...mapMutations(['changeUser']),
  	mmFn(){
      this.yzmshowBool=true;
      this.mmshowBool=false;
  	},
  	yzmFn(){
      this.mmshowBool=true;
      this.yzmshowBool=false;
  	},
  	yhzcFn(){
      this.yzmshowBool=true;
      this.mmshowBool=false;
  	},
  	zszcFn(){
      this.mmshowBool=true;
      this.yzmshowBool=false;
  	},
  	codeCilk(){
  		this.pwdBool=false;
  		this.codeBool=true;
  	},
  	pwdCilk(){
  		this.pwdBool=true;
  		this.codeBool=false;
  	},
  	 changeType() {
        if (this.eye) {
			        this.eye = false
			        this.pwdType = 'password'
			      } else {
			        this.eye = true
			        this.pwdType = 'text'
			      }
     },
  	login1(){
  		 login(this.ruleForm2).then(res =>{//登陆成功
  		 		this.isloading=true;
          if(res.result==1){
          this.isloading=false;
            this.$message({
                message: res.msg,
                type: 'success',
                duration:1000,
                onClose:()=>{
			    			this.setCookietoken(res.token,res.cpy_id,res.userid,res.is_first_login,res.username,7);
			    			this.changeUser({uid:res.userid,token:res.token,uname:res.username});
                this.$router.push({
					        name: `addClinic`
					      })
                
                this.submitForm(this.ruleForm2)
			    				
         		}
					})
        }else{
        	this.isloading=false;
        	this.$message({
                message: res.msg,
                type: 'error',
                duration:1000,
                onClose:()=>{
         		}
					})
        }
  		})
  	},
  	dlfsyzm(val){
  		var reg=11&& /^((13|14|15|17|18)[0-9]{1}\d{8})$/;//手机号正则验证
  		if(!val){
  			this.$message({
            message: "请输入手机号码",
            type: 'warning',
            duration:1000,
            onClose:()=>{
         	}
				})
  		}else if(!reg.test(val)){
  			this.$message({
            message: "请输入正确的手机号码",
            type: 'warning',
            duration:1000,
            onClose:()=>{
         	}
				})
  		}else{
					var data={
						tel:val,
					}
					send_msg_login(data).then(res=>{
						if(res.result==1){
							this.$message({
		            message: "验证码已发送，请注意查收",
		            type: 'success',
		            duration:1000,
		            onClose:()=>{
		            	var TIME_COUNT = 120;
		            	this.dlgrzcsn=res.sn;
					  			if (!this.dltimer) {
						       	this.dlcount = TIME_COUNT;
						       	this.dlyzmshow = false;
						       	this.dltimer = setInterval(() => {
						       	if (this.dlcount > 0 && this.dlcount <= TIME_COUNT) {
						        	 this.dlcount--;
					        	} else {
						         		this.dlyzmshow = true;
						         		clearInterval(this.dltimer);
						         		this.dltimer = null;
												this.dlgrzcsn='';
						        }
						       }, 1000)
						      }
		         		}
							})
						}else{
							this.$message({
			            message: res.msg,
			            type: 'warning',
			            duration:1000,
			            onClose:()=>{
			         	}
							})
						}
					})
					
  		}
  	},
  	loginyzm(){
  		var reg=11&& /^((13|14|15|17|18)[0-9]{1}\d{8})$/;//手机号正则验证
  		if(!reg.test(this.dlphoneval)){
  			this.$message({
	            message: "请输入正确的手机号",
	            type: 'warning',
	            duration:1000,
	            onClose:()=>{
	         	}
				})
  		}else if(this.dlyzmval==""){
  				this.$message({
            message: "请输入验证码",
            type: 'warning',
            duration:1000,
            onClose:()=>{
         	}
				})
  		}else{
  			var data ={
  				tel:this.dlphoneval,
  				sn:this.dlgrzcsn,
  				vcode:this.dlyzmval
  			}
  			login_by_tel(data).then(res=>{
  				if(res.result==1){
  					this.$message({
	            message: res.msg,
	            type: 'success',
	            duration:1000,
	            onClose:()=>{
	            	this.setCookietoken(res.token,res.cpy_id,res.uid,res.is_first_login,res.username,7);
                this.$router.push({
					        name: `AtfirstvisitPatients`,
					        query: {
					         token:res.token,
					         cpy_id:res.cpy_id,
					         uid:res.uid,
					         username:res.username
					        }
					      })
                this.submitForm(this.ruleForm2)
		         	}
						})
  				}else{
	  				this.$message({
	            message: res.msg,
	            type: 'warning',
	            duration:1000,
	            onClose:()=>{
		         	}
						})
  				}
  			})
  		}
  	},
  	fsYzm(val){
  		var reg=11&& /^((13|14|15|17|18)[0-9]{1}\d{8})$/;//手机号正则验证
  		if(!val){
  			this.$message({
            message: "请输入手机号码",
            type: 'warning',
            duration:1000,
            onClose:()=>{
         	}
				})
  		}else if(!reg.test(val)){
  			this.$message({
            message: "请输入正确的手机号码",
            type: 'warning',
            duration:1000,
            onClose:()=>{
         	}
				})
  		}else{
					var data={
						tel:val,
					}
					send_msg_reg(data).then(res=>{
						if(res.result==1){
							this.$message({
		            message: "验证码已发送，请注意查收",
		            type: 'success',
		            duration:1000,
		            onClose:()=>{
		            	var TIME_COUNT = 120;
		            	this.grzcsn=res.sn;
					  			if (!this.timer) {
						       	this.count = TIME_COUNT;
						       	this.yzmshow = false;
						       	this.timer = setInterval(() => {
						       	if (this.count > 0 && this.count <= TIME_COUNT) {
						        	 this.count--;
					        	} else {
						         		this.yzmshow = true;
						         		clearInterval(this.timer);
						         		this.timer = null;
						        }
						       }, 1000)
									var yzmyxq = 300;
						      var times=setInterval(() => {
						       	if (yzmyxq!=0) {
						        	 yzmyxq--;
					        	} else {
											this.grzcsn='';
						        }
						       }, 1000)
						      }
		         		}
							})
						}else{
							this.$message({
			            message: res.msg,
			            type: 'warning',
			            duration:1000,
			            onClose:()=>{
			         	}
							})
						}
					})
					
  		}
  	},
  	grzcFn(){
  		var reg=11&& /^((13|14|15|17|18)[0-9]{1}\d{8})$/;//手机号正则验证
  		if(!reg.test(this.yhsjnum)){
  			this.$message({
            message: "请输入正确的手机号",
            type: 'warning',
            duration:1000,
            onClose:()=>{
         	}
				})
  		}else if(this.gryzmval==''){
	  			this.$message({
	            message: "请输入正确的验证码",
	            type: 'warning',
	            duration:1000,
	            onClose:()=>{
	         	}
				})
  		}else if(6>this.yhmmval.length&&this.yhmmval.length>16){
  			this.$message({
	            message: "请输入6~16位的密码",
	            type: 'warning',
	            duration:1000,
	            onClose:()=>{
	         	}
				})
  		}else if(this.grzcsn==''){
  			this.$message({
	            message: "验证码已过期，请重新获取",
	            type: 'warning',
	            duration:1000,
	            onClose:()=>{
	         	}
				})
  		}else{
  			var data={
  					sn:this.grzcsn,
		    		uTypeID:this.checkLogin,
		    		vcode:this.gryzmval,
		    		uImg:"",
		    		uName:"",
		    		uSex:"",
		    		uBirthday:"",
		    		uTel:this.yhsjnum,
		    		uEmail:'',
		    		uAddr:'',
		    		uMailAddr:'',
		    		uRemark:'',
		    		uGoods:'',
		    		uAuthImg:'',
		    		lUserPwd:this.yhmmval,
		    	}
  			users_reg(data).then(res=>{
  				console.log(res)
  				if(res.result==1){
		  				this.$message({
			            message: "注册成功",
			            type: 'success',
			            duration:1000,
			            onClose:()=>{
			            	this.dengluFn=true;
			            	this.yzmFn();
			         		}
							})
	  			}else{
	  				this.$message({
			            message: res.msg,
			            type: 'warning',
			            duration:1000,
			            onClose:()=>{
			            	
			        	 	}
							})
	  			}
  			})
  		}
  	},
  	//企业注册
  	qyfsyzm(val){
  		var reg=11&& /^((13|14|15|17|18)[0-9]{1}\d{8})$/;//手机号正则验证
  		if(!val){
  			this.$message({
            message: "请输入手机号码",
            type: 'warning',
            duration:1000,
            onClose:()=>{
         	}
				})
  		}else if(!reg.test(val)){
  			this.$message({
            message: "请输入正确的手机号码",
            type: 'warning',
            duration:1000,
            onClose:()=>{
         	}
				})
  		}else{
					var data={
						tel:val,
					}
					send_msg_reg(data).then(res=>{
						if(res.result==1){
							this.$message({
		            message: "验证码已发送，请注意查收",
		            type: 'success',
		            duration:1000,
		            onClose:()=>{
		            	var TIME_COUNT = 120;
		            	this.qyzcsn=res.sn;
					  			if (!this.qytimer) {
						       	this.qycount = TIME_COUNT;
						       	this.qyyzmshow = false;
						       	this.qytimer = setInterval(() => {
						       	if (this.qycount > 0 && this.qycount <= TIME_COUNT) {
						        	 this.qycount--;
					        	} else {
						         		this.qyyzmshow = true;
						         		clearInterval(this.qytimer);
						         		this.qytimer = null;
												this.qyzcsn='';
						        }
						       }, 1000)
									var yzmyxq = 300;
						      var times=setInterval(() => {
						       	if (yzmyxq!=0) {
						        	 yzmyxq--;
					        	} else {
											this.grzcsn='';
						        }
						       }, 1000)
						      }
		         		}
							})
						}else{
							this.$message({
			            message: res.msg,
			            type: 'warning',
			            duration:1000,
			            onClose:()=>{
			         	}
							})
						}
					})
					
  		}
  	},
  	qyzcFn(){
  		var tel = /^0\d{2,3}-?\d{7,8}$/;
  		var reg=11&& /^((13|14|15|17|18)[0-9]{1}\d{8})$/;//手机号正则验证
  		if(this.zsmcval==""){
  			this.$message({
	            message: "请输入诊所名称",
	            type: 'warning',
	            duration:1000,
	            onClose:()=>{
	         	}
				})
  		}else if(this.xxdzval==""){
  			this.$message({
	            message: "请输入详细地址",
	            type: 'warning',
	            duration:1000,
	            onClose:()=>{
	         	}
				})
  		}else if(!tel.test(this.lxdhval)){
				this.$message({
            message: "请输入正确的联系电话",
            type: 'warning',
            duration:1000,
            onClose:()=>{
         	}
				})
  		}else if(this.glzNameval==""){
  			this.$message({
            message: "请输入管理者姓名",
            type: 'warning',
            duration:1000,
            onClose:()=>{
         	}
				})
  		}else if(!reg.test(this.glzlxPhoneval)){
  			this.$message({
            message: "请输入正确的管理者联系电话",
            type: 'warning',
            duration:1000,
            onClose:()=>{
         	}
				})
  		}else if(this.qyyzmval==""){
  			this.$message({
            message: "请输入验证码",
            type: 'warning',
            duration:1000,
            onClose:()=>{
         	}
				})
  		}else{
  			var data={
  				sn:this.qyzcsn,
  				vcode:this.qyyzmval,
  				userpwd:'admin',
  				cTypeID:1,
  				cCityID:110100,
  				cName:this.zsmcval,
  				cCpyTel:this.lxdhval,
  				cPerson:this.glzNameval,
  				cTel:this.glzlxPhoneval,
  				cAddr:this.xxdzval,
  				cLatLng:'',
  				cIsShowSlideSelf:1,
  				cAddTime:'',
  				cUrl:'',
  				cWxImg:'',
  				cImgA:'',
  				cImgB:'',
  				cRoute:'',
  			}
  			console.log(data)
  			company_reg(data).then(res=>{
  					if(res.result==1){
  						this.$message({
			            message: "注册完成，请联系管理员进行审核！",
			            type: 'success',
			            duration:1000,
			            onClose:()=>{
			         	}
							})
  					}else{
  						this.$message({
			            message: res.msg,
			            type: 'warning',
			            duration:1000,
			            onClose:()=>{
			         	}
							})
  					}
  			}).error(
  				console.log('123')
  			)
  		}
  	},
		submitForm(formName) {
         const self = this;
        //判断复选框是否被勾选 勾选则调用配置cookie方法
        if (self.checked == true) {
//          console.log("checked == true");
            //传入账号名，密码，和保存天数3个参数
            self.setCookie(self.ruleForm2.userName, self.ruleForm2.userPwd,6);
        }else {
//        console.log("清空Cookie");
          //清空Cookie
          self.clearCookie();
        }
        
        //与后端请求代码，本功能不需要与后台交互所以省略
        
//      console.log("登陆成功");
		      
		},
		//设置cookie
    setCookie(c_name, c_pwd, exdays) {
        var exdate = new Date(); //获取时间
        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
        //字符串拼接cookie
        window.document.cookie = "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
        window.document.cookie = "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
    },
    //设置cookie储存token
   	setCookietoken(c_token,c_cpy_id,c_uid,is_first_login,username,exdays){
		    	var exdate = new Date(); //获取时间
		        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
		        //字符串拼接cookie
		        window.document.cookie = "token" + "=" + c_token + ";path=/;expires=" + exdate.toGMTString();
		        window.document.cookie = "cpy_id" + "=" + c_cpy_id + ";path=/;expires=" + exdate.toGMTString();
		        window.document.cookie = "uid" + "=" + c_uid + ";path=/;expires=" + exdate.toGMTString();
		        window.document.cookie = "is_first_login" + "=" + is_first_login + ";path=/;expires=" + exdate.toGMTString();
		        window.document.cookie = "username" + "=" + username + ";path=/;expires=" + exdate.toGMTString();
		        
    },
    //读取cookie
    getCookie: function() {
        if (document.cookie.length > 0) {
            var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
//          console.log(arr)
            for (var i = 0; i < arr.length; i++) {
            	this.checked=true;
                var arr2 = arr[i].split('='); //再次切割
                //判断查找相对应的值
                if (arr2[0] == 'userName') {
                    this.ruleForm2.userName = arr2[1]; //保存到保存数据的地方
                } else if (arr2[0] == 'userPwd') {
                    this.ruleForm2.userPwd = arr2[1];
                }
            }
        }
    },
    //设置cookie获取token
    getCookietoken(){
    	 if (document.cookie.length > 0) {
            var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split('='); //再次切割
                //判断查找相对应的值
                if (arr2[0] == 'token') {
                   var token=arr2[1]; //保存到保存数据的地方
                }else if(arr2[0] == 'cpy_id'){
                  var cookiecpy_id=arr2[1]; //保存到保存数据的地方
                }else if(arr2[0] == 'uid'){
                  var cookieuid=arr2[1]; //保存到保存数据的地方
                }
            }
        }
    },
    //清除cookie
    clearCookie: function() {
        this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
    }
  }
}
</script>
<style scoped>
.login{
	width: 1920px;
	height: 888px;
	overflow: hidden;
	position: relative;
	display: flex;
	justify-content: center;
	align-items:center;
	/*background:-webkit-linear-gradient(88deg, rgba(198,198,198,1) 0%, rgba(230,230,230,1) 47%, rgba(222,222,222,1) 100%);
	background:-moz-linear-gradient(88deg, rgba(198,198,198,1) 0%, rgba(230,230,230,1) 47%, rgba(222,222,222,1) 100%);
	background:-o-linear-gradient(88deg, rgba(198,198,198,1) 0%, rgba(230,230,230,1) 47%, rgba(222,222,222,1) 100%);
	background:linear-gradient(88deg, rgba(198,198,198,1) 0%, rgba(230,230,230,1) 47%, rgba(222,222,222,1) 100%);*/
}
.loginBox{
	width:1120px;
	height:758px;
	background:linear-gradient(270deg,rgba(89,92,102,1) 0%,rgba(115,118,127,1) 100%);
	box-shadow:0px 2px 4px 0px rgba(0,0,0,0.5);
}
.loginHeader{
	height: 85px;
	width: 100%;
}
.loginHeader>div:nth-child(1)>img{
	margin: 0 30px;
	width: 355px;
}
.loginHeader>div{
	height: 100%;
	display: flex;
	align-items: center;
	
}
.loginHeader>div:nth-child(2)>i{
	font-size: 24px;
	color: #FFFFFF;
	margin-right: 30px;
}
.loginContent{
	width: 100%;
	height:518px;
}
.loginContent>div:nth-child(1){
	width: 764px;
	height: 100%;
}
.loginContent>div:nth-child(2){
	width:354px;
	/*height:100%;*/
	background:rgba(255,255,255,1);
	position: relative;
	z-index: 999;
}
.loginContent>div:nth-child(2)>div{
	margin:60px 30px 0px 30px;
}
.loginContent>div:nth-child(2)>div>.fromHeader>span:nth-child(1){
	width:200px;
	height:25px;
	font-size:18px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(0,0,0,1);
	line-height:25px;
	float: left;
}
.loginContent>div:nth-child(2)>div>.fromHeader>span:nth-child(2){
	font-size:18px;
	font-family:PingFangSC-Medium;
	font-weight:500;
	color:rgba(0,120,255,1);
	line-height:25px;
	float: right;
	cursor: pointer;
}
.btnDx{
	margin-top: 50px;
	overflow: hidden;
	margin-bottom: 30px;
}
.btnDx>div:hover{
	color:rgba(0,120,255,1);
}
.btnDx>div{
	cursor: pointer;
	float: left;
	width: 114px;
	text-align: center;
	padding:5px 0 ;
	font-size:16px;
	font-family:PingFangSC-Medium,PingFang SC;
	font-weight:500;
	line-height:22px;
	margin: 0 17px;
	border-bottom: 2px solid transparent;
	
}
.btnDx>div.active{
	border-bottom: 2px solid rgba(0, 120, 255, 1);
	color:rgba(0,120,255,1);
	
}
.dlBtn:hover button{
	border:2px solid yellow;
}
.fsyzm:hover{
	color: rgba(0,15,255,1);
}
.el-checkbox__label:hover{
	font-weight: bold !important;
}
.fromHeader>span:nth-child(2):hover{
	font-weight: bold;
}
.fromIpt{
	/*padding-top: 10px;*/
}
.fromIpt>div{
	margin-bottom: 12px;
}
.loginFooter{
	height: 154px;
	position: relative;
}
.loginFooter>div{
	position: absolute;
	top: 73px;
	width:340px;
	left: 30px;
}
.loginFooter>div>p{
	font-size:14px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(255,255,255,1);
	line-height:20px;
}
.loginFooter>div>span{
	font-size:14px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(217,252,255,1);
	line-height:20px;
}
.psd{
	width:281px;
	height:46px;
	background:rgba(245,245,245,1);
	border-radius:3px;
	border: none;
	outline: none;
	padding-left: 15px;
	font-size:16px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(46,52,88,1);
}
.eye{
	width: 25px;
	height: 17px;
	position: absolute;
  top: 14px;
	right: 11px;
	cursor: pointer;
}
.cur{
	font-size:12px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	line-height: 20px;
	color:rgba(74,74,74,1);
}
.dlBtn>button{
	margin-top: 6px;
	width:297px;
	height:40px;
	background:rgba(0,120,255,1);
	box-shadow:0px 1px 4px 0px rgba(121,139,149,0.44);
	border-radius:3px;
	border: none;outline: none;
	font-size:15px;
	font-family:PingFangSC-Medium;
	font-weight:500;
	color:rgba(255,255,255,1);
	cursor: pointer;
	z-index: 999;
}
.fsyzm{
	width:70px;
	height:17px;
	font-size:12px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(0,120,255,1);
	line-height:17px;
	position: absolute;
  top: 14px;
	right: 11px;
	cursor: pointer;
}
.checkLogin>i{
		display: block;
		width: 15px;
		height: 15px;
		border-radius:50% ;
		background: url(../assets/image/圈未选中.png) no-repeat center center;
		background-size:100% ;
		float: left;
		margin-right: 10px;
	}
	.checkLogin>i.active{
		background: url(../assets/image/选中.png) no-repeat center center;
		background-size:100% ;
	}
	.checkLogin{
		color: #000000;
		cursor: pointer;
	}
	
	.mb20{
		margin-bottom:16px !important; 
	}
	.mb60{
		margin-bottom: 60px !important;
	}
	.zcBox{
		height:612px ;
		z-index: 99;
	}
	.dengluBox{
		height:458px;
	}
	.count{
		color: #666666;
		text-align: center;
		cursor: no-drop;
	}
</style>
<style type="text/css">
	.loginContent>div:nth-child(1)>.el-carousel{
		width: 764px;
		height: 518px;
	}
	.loginContent>div:nth-child(1)>.el-carousel>.el-carousel__container{
		width: 764px;
		height: 518px;
	}
	.loginContent>div:nth-child(1)>.el-carousel>.el-carousel__container>.el-carousel__item>img{
		width: 764px;
		height: 518px;
	}
	.loginContent>div:nth-child(1)>.el-carousel>.el-carousel__container>.el-carousel__arrow--right{
		display: none;
	}
	.loginContent>div:nth-child(1)>.el-carousel>.el-carousel__container>.el-carousel__arrow--left{
		display: none;
	}
	.loginContent>div:nth-child(1)>.el-carousel>.el-carousel__indicators--horizontal{
		left: 20%;
	}
	.loginContent>div:nth-child(1)>.el-carousel>.el-carousel__indicators--horizontal>.el-carousel__indicator>button{
		width:17px;
		height:6px;
		background:rgba(217,218,222,0.5);
		border-radius:3px;
	}
	.loginContent>div:nth-child(1)>.el-carousel>.el-carousel__indicators--horizontal>.el-carousel__indicator.is-active>button{
		width:33px;
		height:6px;
		background:rgba(217,218,222,1);
		border-radius:3px;
	}
	.loginContent .el-checkbox__inner{
	border-radius: 50%;
	width:20px;
	height:20px;
	background:rgba(216,216,216,1);
	text-align: center;
}
.loginContent .el-checkbox__inner:hover{
	border: none;
}
.line_02{
  margin: 20px 0;
  text-align: center;
  font-size:11px;
	font-family:PingFangSC-Medium;
	font-weight:500;
	color:#c4c4c4;
	line-height:16px;
	position: relative;
}
.line_02::before{
	width:80px;
	height:1px;
	display: block;
	content: "";
	background:linear-gradient(-90deg,rgba(0,0,0,.07), rgba(255,255,255));
	position: absolute;
	top: 50%;
	left: 32px;
}
.line_02::after{
	width:80px;
	height:1px;
	display: block;
	content: "";
	background:linear-gradient(90deg,rgba(0,0,0,.07), rgba(255,255,255));
	position: absolute;
	top: 50%;
	right: 32px;
}
.line_01{
  margin: 20px 0;
  text-align: center;
  font-size:11px;
	font-family:PingFangSC-Medium;
	font-weight:500;
	color:#c4c4c4;
	line-height:16px;
	position: relative;
}
.line_01::before{
	width:80px;
	height:1px;
	display: block;
	content: "";
	background:linear-gradient(-90deg,rgba(0,0,0,.07), rgba(255,255,255));
	position: absolute;
	top: 50%;
	left: 50px;
}
.line_01::after{
	width:80px;
	height:1px;
	display: block;
	content: "";
	background:linear-gradient(90deg,rgba(0,0,0,.07), rgba(255,255,255));
	position: absolute;
	top: 50%;
	right: 50px;
}
/*记住密码*/
.loginContent .el-checkbox__input{
	
}
.loginContent .el-checkbox__input.is-checked .el-checkbox__inner{
	width:20px;
	height:20px;
	background-color:#0078FF ;
	border: none;
}
.loginContent .el-checkbox__inner::after{
	height: 10px;
	width: 5px;
	margin-left: 3px;
	margin-top: 1px;
	font-size:14px ;
}
.loginContent .el-checkbox__label{
	font-size:12px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(137,140,147,1);
	}
</style>


// WEBPACK FOOTER //
// src/components/login.vue